import { render } from "./IconLegend.vue?vue&type=template&id=47407d7e&scoped=true"
import script from "./IconLegend.vue?vue&type=script&lang=js"
export * from "./IconLegend.vue?vue&type=script&lang=js"

import "./IconLegend.vue?vue&type=style&index=0&id=47407d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47407d7e"]])

export default __exports__